import React, { useState, useContext, useEffect } from "react";
import Section from "../../UIcomponent/Section";
import "./LoginRegister.scss";
import Col from "../../UIcomponent/Column";
import LocalContext from "../../Context/LocalContetxt";
import Text from "../../UIcomponent/Text";
import LoginForm from "./LoginForm";
import RegisterForm from "./RegisterForm";
import LoginRegisterContext from "../../Context/LoginRegisterContext";
import DateTime from "../../Utility/Method/DateTime";
import LoginRegisterReq from "../../Utility/Requester/LoginRegisterReq";
import LocalToken from "../../Utility/Method/LocalToken";
import { Formik } from "formik";
import { StyledForm } from "../../UIcomponent/Form";
import { ThemeContext } from "styled-components";
import {
  SendVerifyCodeByEmailSchema,
  SendVerifyCodeByMobileSchema,
  LoginByMobileSchema,
  LoginByEmailSchema,
  ForgotPasswordByPhoneSchema,
  ForgotPasswordByEmailSchema,
  NewPasswordSchema,
} from "../../Utility/ValidationSchema";
import ForgotPasswordForm from "./ForgotPasswordForm";
import LocalConfig from "../../Utility/Method/LocalConfig";
import PhoneNumber from "../../Utility/Method/PhoneNumber";
import { Notify } from "../../UIcomponent/NotificationManager";
import Cookies from "js-cookie";

const LoginRegister = (props) => {
  const { mode } = props;
  const lang = useContext(LocalContext).lang;
  const InfoCtxt = useContext(LoginRegisterContext);
  const localCtxt = useContext(LocalContext);
  const theme = useContext(ThemeContext);
  let routeHistory =
    props.location && props.location.state && props.location.state.from
      ? props.location.state.from.pathname
      : null;
  const codeExpireDuration = 120 * 1000;
  const [State, setState] = useState({
    flowType: "mobile",
    mode: mode ? mode : "register",
    expireTime: null,
    hasVerifyCode: false,
    verifyCodeStatus: false,
    shake: false,
    VerifiedID: null,
  });
  const [info, setInfo] = useState({
    PhoneNumber: "",
    VerifiedID: "",
    FirstName: "",
    LastName: "",
    Code: "",
    phoneCode: "+98",
    timeZone: DateTime.timeZone(),
  });
  const FlowType = [
    {
      title: {
        fa: "شماره موبایل",
      },
      value: "mobile",
    },
    {
      title: {
        fa: "ایمیل",
      },
      value: "email",
    },
  ];
  const flowTypeHandler = (type, formikProps) => {
    setState({
      ...State,
      flowType: type,
    });
    formikProps.resetForm();
  };
  const modeHandler = (type) => {
    if (type === "register") {
      setState({
        ...State,
        mode: type,
        hasVerifyCode: false,
        expireTime: null,
      });
    } else {
      setState({
        ...State,
        mode: type,
        hasVerifyCode: false,
        expireTime: null,
      });
    }
  };
  const formErrosStyle = (justifyContent) => {
    return {
      display: "flex",
      justifyContent: justifyContent || "flex-start",
      backgroundColor: "white",
      minHeight: "15px",
      maxHeight: "15px",
      color: theme.danger,
      borderRadius: "5px",
      alignSelf: "flex-start",
      fontSize: theme.fontSizeXs,
      fontWeight: 600,
    };
  };
  const FormEdit = (type) => {
    setState({
      ...State,
      mode: type,
      hasVerifyCode: false,
    });
  };
  useEffect(() => {
    mode &&
      setState({
        ...State,
        mode,
      });
  }, [info]);
  const ResendCode = (actions, values) => {
    let Body;
    actions.setSubmitting(true);
    if (State.flowType === "mobile") {
      Body = {
        PhoneNumber: PhoneNumber.CodeHandler(values.mobile, values.phoneCode),
      };
      return LoginRegisterReq.SendPhoneVerifyCode(Body)
        .then((res) => {
          actions.setSubmitting(false);
          setState({
            ...State,
            hasVerifyCode: true,
            expireTime: Date.now() + codeExpireDuration,
          });
        })
        .catch((err) => {
          actions.setSubmitting(false);
          Notify("error", err.response.data.message);
        });
    } else {
      Body = {
        Email: values.email,
      };
      return LoginRegisterReq.SendEmailVerifyCode(Body)
        .then((res) => {
          actions.setSubmitting(false);
          setState({
            ...State,
            hasVerifyCode: true,
            expireTime: Date.now() + codeExpireDuration,
          });
        })
        .catch((err) => {
          actions.setSubmitting(false);
          Notify("error", err.response.data.message);
        });
    }
  };
  const ForgotPasswordSendCode = (actions, values) => {
    let Body;
    actions.setSubmitting(true);
    if (State.flowType === "mobile") {
      Body = {
        PhoneNumber: PhoneNumber.CodeHandler(values.mobile, values.phoneCode),
      };
      return LoginRegisterReq.forgotPasswordSendPhone(Body)
        .then((res) => {
          actions.setSubmitting(false);
          setState({
            ...State,
            hasVerifyCode: true,
            expireTime: Date.now() + codeExpireDuration,
          });
        })
        .catch((err) => {
          actions.setSubmitting(false);
          Notify("error", err.response.data.message);
        });
    } else {
      Body = {
        Email: values.email,
      };
      return LoginRegisterReq.forgotPasswordSendEmail(Body)
        .then((res) => {
          actions.setSubmitting(false);
          setState({
            ...State,
            hasVerifyCode: true,
            expireTime: Date.now() + codeExpireDuration,
          });
          actions.setSubmitting(false);
        })
        .catch((err) => {
          actions.setSubmitting(false);
          Notify("error", err.response.data.message);
        });
    }
  };
  return (
    localCtxt.hasToken === false && (
      <LoginRegisterContext.Provider
        value={{
          info,
          setInfo,
        }}
      >
        <Formik
          enableReinitialize={true}
          initialValues={{
            mobile: "",
            email: "",
            pass: "",
            phoneCode: InfoCtxt.info.phoneCode,
            firstName: "",
            lastName: "",
            code: "",
            timezone: InfoCtxt.info.timeZone,
          }}
          validationSchema={
            State.mode === "login" && State.flowType === "mobile"
              ? LoginByMobileSchema(info.phoneCode)
              : State.mode === "login" && State.flowType === "email"
              ? LoginByEmailSchema
              : State.mode === "register" && State.flowType === "mobile"
              ? SendVerifyCodeByMobileSchema(info.phoneCode)
              : State.mode === "register" && State.flowType === "email"
              ? SendVerifyCodeByEmailSchema
              : State.mode === "forgotPassword" &&
                State.flowType === "mobile" &&
                State.verifyCodeStatus === false
              ? ForgotPasswordByPhoneSchema(info.phoneCode)
              : State.mode === "forgotPassword" &&
                State.flowType === "email" &&
                State.verifyCodeStatus === false
              ? ForgotPasswordByEmailSchema
              : State.mode === "forgotPassword" &&
                State.verifyCodeStatus === true
              ? NewPasswordSchema
              : null
          }
          //   validationSchema={LoginByMobileSchema}
          // validator={() => ({})}
          // isInitialValid={false}
          validateOnMount={true}
          isSubmitting={false}
          autocomplete={false}
          onSubmit={(values, actions) => {
            if (State.mode === "login") {
              let Body = {
                Username:
                  State.flowType === "mobile"
                    ? PhoneNumber.CodeHandler(values.mobile, values.phoneCode)
                    : values.email,
                Password: values.pass,
              };
              actions.setSubmitting(true);
              LoginRegisterReq.Login(Body)
                .then((res) => {
                  LocalConfig.Remove();
                  LocalToken.Remove();
                  LocalToken.Set(res);
                  Cookies.set("LINGO_ACCESS_TOKEN", res.data.AccessToken);
                  Cookies.set("LINGO_REFRESH_TOKEN", res.data.RefreshToken);
                  localCtxt.setHasToken(true);
                  actions.setSubmitting(false);
                  if (window.location.pathname === "/login") {
                    if (routeHistory) {
                      return window.location.replace(routeHistory);
                    } else {
                      window.location.replace("/dashboard");
                    }
                  } else {
                    // localCtxt.setHasToken(true)
                    window.location.reload();
                  }
                  LocalConfig.Remove();
                })
                .catch((err) => {
                  actions.setSubmitting(false);
                  err.response && Notify("error", err.response.data.message);
                });
            } else if (
              State.mode === "register" &&
              State.hasVerifyCode === false
            ) {
              let Body;
              actions.setSubmitting(true);
              if (State.flowType === "mobile") {
                Body = {
                  PhoneNumber: PhoneNumber.CodeHandler(
                    values.mobile,
                    values.phoneCode
                  ),
                };
                return LoginRegisterReq.SendPhoneVerifyCode(Body)
                  .then((res) => {
                    actions.setSubmitting(false);
                    setState({
                      ...State,
                      hasVerifyCode: true,
                      expireTime: Date.now() + codeExpireDuration,
                    });
                  })
                  .catch((err) => {
                    actions.setSubmitting(false);
                    Notify("error", err.response.data.message);
                  });
              } else {
                Body = {
                  Email: values.email,
                };
                return LoginRegisterReq.SendEmailVerifyCode(Body)
                  .then((res) => {
                    actions.setSubmitting(false);
                    setState({
                      ...State,
                      hasVerifyCode: true,
                      expireTime: Date.now() + codeExpireDuration,
                    });
                  })
                  .catch((err) => {
                    actions.setSubmitting(false);
                    Notify("error", err.response.data.message);
                  });
              }
            } else if (
              State.mode === "register" &&
              State.hasVerifyCode === true
            ) {
              if (State.flowType === "mobile") {
                let Data = {
                  PhoneNumber: PhoneNumber.CodeHandler(
                    values.mobile,
                    values.phoneCode
                  ),
                  Code: values.code,
                };
                setState({
                  ...State,
                  shake: false,
                });
                LoginRegisterReq.PhoneVerifyCode(Data)
                  .then((Res) => {
                    let Body = {
                      PhoneNumber: PhoneNumber.CodeHandler(
                        values.mobile,
                        values.phoneCode
                      ),
                      VerifiedID: Res.data.VerifiedID,
                      Password: values.pass,
                      FirstName: values.firstName,
                      LastName: values.lastName,
                      TimeZone: values.timezone,
                    };
                    LoginRegisterReq.StudentRegisterByPhone(Body)
                      .then((res) => {
                        localStorage.clear();
                        actions.setSubmitting(false);
                        setState({
                          ...State,
                          hasVerifyCode: true,
                        });
                        LocalToken.Set(res);
                        Cookies.set("LINGO_ACCESS_TOKEN", res.data.AccessToken);
                        Cookies.set(
                          "LINGO_REFRESH_TOKEN",
                          res.data.RefreshToken
                        );
                        // localCtxt.setHasToken(true);
                        if (window.location.pathname === "/login") {
                          if (routeHistory) {
                            return window.location.replace(routeHistory);
                          } else {
                            window.location.replace("/dashboard");
                          }
                        } else {
                          window.location.reload();
                        }
                      })
                      .catch((err) => {
                        actions.setSubmitting(false);
                        Notify("error", err.response.data.message);
                      });
                  })
                  .catch((err) => {
                    actions.setSubmitting(false);
                    setState({
                      ...State,
                      shake: true,
                    });
                    actions.setFieldValue("code", "");
                    Notify("error", err.response.data.message);
                  });
              } else {
                let Data = {
                  Email: values.email,
                  Code: values.code,
                };
                setState({
                  ...State,
                  shake: false,
                });
                LoginRegisterReq.EmailVerifyCode(Data)
                  .then((Res) => {
                    let Body = {
                      Email: values.email,
                      VerifiedID: Res.data.VerifiedID,
                      Password: values.pass,
                      FirstName: values.firstName,
                      LastName: values.lastName,
                      TimeZone: values.timezone,
                    };
                    LoginRegisterReq.StudentRegisterByEmail(Body)
                      .then((res) => {
                        actions.setSubmitting(false);
                        setState({
                          ...State,
                          hasVerifyCode: true,
                        });
                        LocalToken.Set(res);
                        Cookies.set("LINGO_ACCESS_TOKEN", res.data.AccessToken);
                        Cookies.set(
                          "LINGO_REFRESH_TOKEN",
                          res.data.RefreshToken
                        );
                        localCtxt.setHasToken(true);
                        if (window.location.pathname === "/login") {
                          if (routeHistory) {
                            return window.location.replace(routeHistory);
                          } else {
                            window.location.replace("/dashboard");
                          }
                        }
                      })
                      .catch((err) => {
                        actions.setSubmitting(false);
                        Notify("error", err.response.data.message);
                      });
                  })
                  .catch((err) => {
                    actions.setSubmitting(false);
                    setState({
                      ...State,
                      shake: true,
                    });
                    actions.setFieldValue("code", "");
                    Notify("error", err.response.data.message);
                  });
              }
            } else if (
              State.mode === "forgotPassword" &&
              State.hasVerifyCode === false
            ) {
              let Body;
              actions.setSubmitting(true);
              if (State.flowType === "mobile") {
                Body = {
                  PhoneNumber: PhoneNumber.CodeHandler(
                    values.mobile,
                    values.phoneCode
                  ),
                };
                return LoginRegisterReq.forgotPasswordSendPhone(Body)
                  .then((res) => {
                    actions.setSubmitting(false);
                    setState({
                      ...State,
                      hasVerifyCode: true,
                      expireTime: Date.now() + codeExpireDuration,
                    });
                  })
                  .catch((err) => {
                    actions.setSubmitting(false);
                    Notify("error", err.response.data.message);
                  });
              } else {
                Body = {
                  Email: values.email,
                };
                return LoginRegisterReq.forgotPasswordSendEmail(Body)
                  .then((res) => {
                    actions.setSubmitting(false);
                    setState({
                      ...State,
                      hasVerifyCode: true,
                      expireTime: Date.now() + codeExpireDuration,
                    });
                    actions.setSubmitting(false);
                  })
                  .catch((err) => {
                    actions.setSubmitting(false);
                    Notify("error", err.response.data.message);
                  });
              }
            } else if (
              State.mode === "forgotPassword" &&
              State.hasVerifyCode === true &&
              State.verifyCodeStatus === false
            ) {
              if (State.flowType === "mobile") {
                let Data = {
                  PhoneNumber: PhoneNumber.CodeHandler(
                    values.mobile,
                    values.phoneCode
                  ),
                  Code: values.code,
                };
                LoginRegisterReq.ForgotPasswordVerifyPhoneCode(Data)
                  .then((Res) => {
                    setState({
                      ...State,
                      VerifiedID: Res.data.VerifiedID,
                      verifyCodeStatus: true,
                    });
                    let Data = {
                      PhoneNumber: PhoneNumber.CodeHandler(
                        values.mobile,
                        values.phoneCode
                      ),
                      VerifiedID: Res.data.VerifiedID,
                      Password: values.pass,
                    };
                    LoginRegisterReq.ForgotPassowrdPhoneUpdate(Data)
                      .then((res) => {
                        actions.setSubmitting(false);
                        LocalToken.Set(res);
                        Cookies.set("LINGO_ACCESS_TOKEN", res.data.AccessToken);
                        Cookies.set(
                          "LINGO_REFRESH_TOKEN",
                          res.data.RefreshToken
                        );
                        localCtxt.setHasToken(true);
                        if (window.location.pathname === "/login") {
                          if (routeHistory) {
                            return window.location.replace(routeHistory);
                          } else {
                            window.location.replace("/dashboard");
                          }
                        } else {
                          window.location.reload();
                        }
                      })
                      .catch((err) => {
                        actions.setSubmitting(false);
                        Notify("error", err.response.data.message);
                      });
                  })
                  .catch((err) => {
                    setState({
                      ...State,
                      shake: true,
                      expireTime: null,
                    });
                    actions.setSubmitting(false);
                    Notify("error", err.response.data.message);
                  });
              } else {
                let Data = {
                  Email: values.email,
                  Code: values.code,
                };
                LoginRegisterReq.ForgotPasswordVerifyEmailCode(Data)
                  .then((Res) => {
                    setState({
                      ...State,
                      VerifiedID: Res.data.VerifiedID,
                      verifyCodeStatus: true,
                    });
                    let Data = {
                      PhoneNumber: values.email,
                      VerifiedID: Res.data.VerifiedID,
                      Password: values.pass,
                    };
                    LoginRegisterReq.ForgotPassowrdPhoneUpdate(Data)
                      .then((res) => {
                        actions.setSubmitting(false);
                        LocalToken.Set(res);
                        Cookies.set("LINGO_ACCESS_TOKEN", res.data.AccessToken);
                        Cookies.set(
                          "LINGO_REFRESH_TOKEN",
                          res.data.RefreshToken
                        );
                        localCtxt.setHasToken(true);
                        if (window.location.pathname === "/login") {
                          if (routeHistory) {
                            return window.location.replace(routeHistory);
                          } else {
                            window.location.replace("/dashboard");
                          }
                        } else {
                          window.location.reload();
                        }
                      })
                      .catch((err) => {
                        actions.setSubmitting(false);
                        Notify("error", err.response.data.message);
                      });
                    // actions.setSubmitting(false)
                  })
                  .catch((err) => {
                    setState({
                      ...State,
                      shake: true,
                      expireTime: null,
                    });
                    actions.setSubmitting(false);
                    Notify("error", err.response.data.message);
                  });
              }
            } else if (
              State.mode === "forgotPassword" &&
              State.hasVerifyCode === true &&
              State.verifyCodeStatus === true
            ) {
            } else {
              return null;
            }
          }}
        >
          {(formik) => (
            <Col
              style={{
                flexDirection: "column",
              }}
            >
              <Section
                className={`l__LoginRegister ${
                  State.shake === true && "l__LoginRegister--Shake"
                } `}
              >
                <StyledForm autoComplete={false} onSubmit={formik.handleSubmit}>
                  {State.hasVerifyCode === false && (
                    <Col
                      xl={20}
                      lg={21}
                      md={22}
                      sm={22}
                      xs={22}
                      className="c__FlowType"
                    >
                      {FlowType.map((type) => {
                        return (
                          <Col
                            className="o__FlowType"
                            onClick={() => {
                              flowTypeHandler(type.value, formik);
                            }}
                          >
                            <Text
                              className={`${
                                type.value === State.flowType &&
                                "o__FlowType--active"
                              }`}
                            >
                              {type.title[`${lang}`]}
                            </Text>
                            {type.value === State.flowType && <span></span>}
                          </Col>
                        );
                      })}
                    </Col>
                  )}
                  <Col
                    xl={20}
                    lg={22}
                    md={22}
                    sm={22}
                    xs={22}
                    className="c__Form"
                  >
                    {State.mode === "login" && (
                      <LoginForm
                        lang={lang}
                        State={State}
                        setState={setState}
                        info={info}
                        setInfo={setInfo}
                        flowType={State.flowType}
                        formikProps={formik}
                        formik={formik}
                        formErrosStyle={formErrosStyle}
                      />
                    )}
                    {State.mode === "register" && (
                      <RegisterForm
                        lang={lang}
                        State={State}
                        setState={setState}
                        flowType={State.flowType}
                        formikProps={formik}
                        formik={formik}
                        info={info}
                        setInfo={setInfo}
                        FormEdit={FormEdit}
                        formErrosStyle={formErrosStyle}
                        ResendCode={ResendCode}
                      />
                    )}
                    {State.mode === "forgotPassword" && (
                      <ForgotPasswordForm
                        lang={lang}
                        State={State}
                        setState={setState}
                        flowType={State.flowType}
                        formikProps={formik}
                        formik={formik}
                        info={info}
                        setInfo={setInfo}
                        FormEdit={FormEdit}
                        ResendCode={ForgotPasswordSendCode}
                        formErrosStyle={formErrosStyle}
                      />
                    )}
                  </Col>
                  <Col
                    // style={{
                    //     margin: State.mode === 'register' && State.hasVerifyCode === true ? '15px 0px 15px 0px' : '0px'
                    // }}
                    xl={20}
                    lg={22}
                    md={22}
                    sm={22}
                    xs={22}
                    className="c__ModeHandler"
                  ></Col>
                </StyledForm>
              </Section>
              {State.hasVerifyCode === false &&
                State.mode !== "forgotPassword" && (
                  <Section className="l__ModeHandler">
                    <Col
                      xl={24}
                      lg={24}
                      md={24}
                      sm={24}
                      xs={24}
                      style={{
                        height: "100%",
                        margin: "0px",
                      }}
                    >
                      <Col
                        xl={9.5}
                        lg={11}
                        md={11}
                        sm={11}
                        xs={11}
                        style={{
                          height: "100%",
                          margin: "0px 0px 0px 0px",
                          justifyContent: "flex-start",
                          // color: theme.text,
                          fontSize: theme.fontSizeMd,
                        }}
                      >
                        {State.mode === "register"
                          ? "قبلا ثبت نام کرده اید؟"
                          : "حساب کاربری ندارید؟"}
                      </Col>
                      <Col
                        xl={9.5}
                        lg={11}
                        md={11}
                        sm={11}
                        xs={11}
                        style={{
                          height: "100%",
                          fontWeight: 800,
                          margin: "0px 0px 0px 0px",
                          justifyContent: "flex-end",
                          color: theme.primary,
                          fontSize: theme.fontSizelg,
                          cursor: "pointer",
                        }}
                        onClick={
                          State.hasVerifyCode === false &&
                          State.mode !== "forgotPassword"
                            ? () => {
                                modeHandler(
                                  State.mode === "login" ? "register" : "login"
                                );
                                formik.resetForm();
                              }
                            : null
                        }
                      >
                        {State.mode === "register" ? "ورود" : "ثبت نام"}
                      </Col>
                    </Col>
                  </Section>
                )}
            </Col>
          )}
        </Formik>
      </LoginRegisterContext.Provider>
    )
  );
};

export default LoginRegister;
